import React, { useEffect, useState, Component } from 'react';
import { MessageCircle, Send, MapPin, Mail, Phone, CheckCircle, Clock } from 'lucide-react';
function LiveClock({
  timezone,
  label,
  flag
}: {
  timezone: string;
  label: string;
  flag: string;
}) {
  const [time, setTime] = useState('');
  useEffect(() => {
    const update = () => {
      const now = new Date();
      const formatted = now.toLocaleTimeString('en-IE', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
      setTime(formatted);
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [timezone]);
  return <div className="flex items-center space-x-3 border border-white/[0.08] rounded-lg px-4 py-3" style={{
    backgroundColor: '#0d0d0d'
  }} data-id="element-82">
      <span className="text-2xl" data-id="element-83">{flag}</span>
      <div data-id="element-84">
        <p className="text-white/40 text-xs font-medium uppercase tracking-wider" data-id="element-85">
          {label}
        </p>
        <p className="text-white font-mono text-lg font-bold tabular-nums" data-id="element-86">
          {time || '--:--:--'}
        </p>
      </div>
    </div>;
}
export function ContactSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      await fetch('https://formsubmit.co/ajax/nmservicesww@gmail.com', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });
      setIsSubmitted(true);
    } catch (err) {
      // Fallback: open mailto with form data
      const name = formData.get('name') || '';
      const contact = formData.get('contact') || '';
      const business = formData.get('business') || '';
      const website = formData.get('website') || '';
      const message = formData.get('message') || '';
      const subject = `Website Quote Request from ${name}`;
      const body = `Name: ${name}\nContact: ${contact}\nBusiness Type: ${business}\nCurrent Website: ${website}\n\nMessage:\n${message}`;
      window.location.href = `mailto:nmservicesww@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      setIsSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contact" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-87">
      <div className="max-w-5xl mx-auto" data-id="element-88">
        <div className="text-center mb-12 reveal" data-id="element-89">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-90">
            Get Your Dublin Website Quote
          </h2>
          <p className="text-white/60" data-id="element-91">Fast response. No obligation.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-92">
          <div className="space-y-8 reveal" data-id="element-93">
            <div className="space-y-4" data-id="element-94">
              <h3 className="text-xl font-bold text-white" data-id="element-95">Quick Chat</h3>
              <div className="flex flex-col space-y-3" data-id="element-96">
                <a href="https://wa.me/36707559881?text=Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC249%20website%20package.%20My%20business%20is%3A%20____" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 bg-[#25D366] hover:bg-[#20bd5a] text-white py-3 rounded-lg font-medium transition-colors" data-id="element-97">
                  <MessageCircle className="w-5 h-5" data-id="element-98" />
                  <span data-id="element-99">Chat on WhatsApp</span>
                </a>
                <a href="https://line.me/ti/p/VcfecNpfWu" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 bg-[#06C755] hover:bg-[#05b54d] text-white py-3 rounded-lg font-medium transition-colors" data-id="element-100">
                  <MessageCircle className="w-5 h-5" data-id="element-101" />
                  <span data-id="element-102">Chat on LINE</span>
                </a>
              </div>
            </div>

            <div className="space-y-4 pt-4 border-t border-white/10" data-id="element-103">
              <h3 className="text-xl font-bold text-white" data-id="element-104">Contact Details</h3>
              <ul className="space-y-4" data-id="element-105">
                <li className="flex items-start space-x-3" data-id="element-106">
                  <Mail className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-107" />
                  <span className="text-white/80" data-id="element-108">nmservicesww@gmail.com</span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-109">
                  <Phone className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-110" />
                  <div className="text-white/80" data-id="element-111">
                    <p data-id="element-112">Netanel: +66 096 023 1920 (LINE)</p>
                    <p data-id="element-113">WhatsApp: +36 70 755 9881</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3" data-id="element-114">
                  <Phone className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-115" />
                  <span className="text-white/80" data-id="element-116">
                    Vlad: +66 093 337 6318 (LINE)
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-117">
                  <MapPin className="w-5 h-5 text-[#c9a84c] mt-1" data-id="element-118" />
                  <span className="text-white/80" data-id="element-119">
                    Remote • Dublin-first support
                  </span>
                </li>
              </ul>
            </div>

            {/* Digital Nomad fun note */}
            <div className="pt-4 border-t border-white/10 space-y-4" data-id="element-120">
              <p className="text-white/50 text-sm italic leading-relaxed" data-id="element-121">
                🌴 Sorry for the Thai number — we're digital nomads living in
                Thailand! Netanel can also sort you the vacation you need. Check
                him out:
              </p>
              <div className="flex space-x-3" data-id="element-122">
                <a href="https://www.instagram.com/netaneltoursvip" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 px-4 py-2.5 rounded-lg font-medium text-sm text-white transition-all hover:scale-105" style={{
                background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)'
              }} data-id="element-123">
                  <svg className="w-5 h-5 fill-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-124">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-125" />
                  </svg>
                  <span data-id="element-126">Instagram</span>
                </a>
                <a href="https://www.tiktok.com/@netaneltoursvip" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 px-4 py-2.5 rounded-lg font-medium text-sm text-white bg-black border border-white/20 transition-all hover:scale-105 hover:border-white/40" data-id="element-127">
                  <svg className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-128">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13a8.28 8.28 0 005.58 2.15v-3.44a4.85 4.85 0 01-1.99-.43V6.69h1.99z" fill="#25F4EE" data-id="element-129" />
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13a8.28 8.28 0 005.58 2.15v-3.44a4.85 4.85 0 01-1.99-.43V6.69h1.99z" fill="#FE2C55" style={{
                    transform: 'translate(2px, -2px)'
                  }} data-id="element-130" />
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13a8.28 8.28 0 005.58 2.15v-3.44a4.85 4.85 0 01-1.99-.43V6.69h1.99z" fill="white" data-id="element-131" />
                  </svg>
                  <span data-id="element-132">TikTok</span>
                </a>
              </div>

              {/* Live Clocks */}
              <div className="pt-4 space-y-3" data-id="element-133">
                <div className="flex items-center space-x-2" data-id="element-134">
                  <Clock className="w-4 h-4 text-[#c9a84c]" data-id="element-135" />
                  <p className="text-white/50 text-sm" data-id="element-136">
                    Check the times so you know when to reach us!
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-3" data-id="element-137">
                  <LiveClock timezone="Europe/Dublin" label="Ireland" flag="🇮🇪" data-id="element-138" />
                  <LiveClock timezone="Asia/Bangkok" label="Thailand" flag="🇹🇭" data-id="element-139" />
                </div>
              </div>
            </div>
          </div>

          <div className="p-8 rounded-xl border border-white/[0.06] reveal" style={{
          backgroundColor: '#0a0a0a'
        }} data-id="element-140">
            {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center space-y-4 py-12" data-id="element-141">
                <div className="w-16 h-16 bg-[#c9a84c]/20 rounded-full flex items-center justify-center" data-id="element-142">
                  <CheckCircle className="w-8 h-8 text-[#c9a84c]" data-id="element-143" />
                </div>
                <h3 className="text-2xl font-bold text-white" data-id="element-144">Request Sent!</h3>
                <p className="text-white/70" data-id="element-145">
                  Thanks! We'll get back to you within a few hours.
                </p>
                <button onClick={() => setIsSubmitted(false)} className="text-[#c9a84c] hover:underline mt-4" data-id="element-146">
                  Send another message
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-147">
                {/* FormSubmit.co config */}
                <input type="hidden" name="_subject" value="New Website Quote Request — aiwebsitepackage.com" data-id="element-148" />
                <input type="hidden" name="_template" value="table" data-id="element-149" />
                <input type="hidden" name="_captcha" value="false" data-id="element-150" />

                {[{
              label: 'Name *',
              name: 'name',
              placeholder: 'Your name',
              required: true
            }, {
              label: 'Email or WhatsApp *',
              name: 'contact',
              placeholder: 'How can we reach you?',
              required: true
            }, {
              label: 'Business Type *',
              name: 'business',
              placeholder: 'e.g. Restaurant, Plumber, Shop',
              required: true
            }, {
              label: 'Current Website (Optional)',
              name: 'website',
              placeholder: 'example.com',
              required: false
            }].map(field => <div key={field.name} data-id="element-151">
                    <label className="block text-sm font-medium text-white/60 mb-1" data-id="element-152">
                      {field.label}
                    </label>
                    <input type="text" name={field.name} required={field.required} className="w-full border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:border-[#c9a84c] focus:ring-1 focus:ring-[#c9a84c] outline-none transition-all" style={{
                backgroundColor: '#111111'
              }} placeholder={field.placeholder} data-id="element-153" />
                  </div>)}
                <div data-id="element-154">
                  <label className="block text-sm font-medium text-white/60 mb-1" data-id="element-155">
                    Message
                  </label>
                  <textarea name="message" rows={4} className="w-full border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:border-[#c9a84c] focus:ring-1 focus:ring-[#c9a84c] outline-none transition-all resize-none" style={{
                backgroundColor: '#111111'
              }} placeholder="Tell us about your needs..." data-id="element-156"></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className="w-full bg-[#c9a84c] hover:bg-[#b09242] disabled:opacity-60 text-black font-bold py-4 rounded-lg transition-colors flex items-center justify-center space-x-2" data-id="element-157">
                  <span data-id="element-158">
                    {isSubmitting ? 'Sending...' : 'Send Quote Request'}
                  </span>
                  <Send className="w-4 h-4" data-id="element-159" />
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}